import React, { useState, useEffect, useMemo } from "react"
import { useLocation, useHistory } from "react-router"
import { useMediaQuery } from "react-responsive"
import { Button } from "antd"
import Row from "src/components/row"
import Avatar from "src/components/avatar"
import { images } from "src/assets"
import { timeStampTo_M_Day } from "src/dashboards/components/stamptime-converter"
import "./style.scss"
import Footer from "src/components/footer"
import { Helmet } from "react-helmet"

import GoogleAdSense from "src/components/google-ad-sense"
import {
  BlogDateTime,
  BlogDetail,
  BlogListContainer,
  DivCard,
  Card,
  ClientDetail,
  ClientImageSection,
  ClientName,
  SingleBlogContainer,
  Heading,
  TitleTxt,
  ImageContainer,
  MoreBlogContainer,
  MoreBlogImage,
  TabContainer,
  Content,
  TopSection,
  DescText,
  BannerImageContainer,
  BannerImage,
  TagContainer,
  TagsList
} from "./UI"
import Hero from "src/components/hero"
import ApolloClient from "apollo-client"
import { NormalizedCacheObject } from "apollo-cache-inmemory"
import { fetchBlog, fetchMoreBlogList } from "./utils/services"
import SkeletonLoading from "src/components/skeleton-loading"
import { SkeletonWrapper } from "../blogs"
import { Link } from "react-router-dom"
import AuthenticationState from "src/hoc/authentication/authentication.state"
import Column from "src/components/column"
import { removeExtraUrlSymbols, editAltToblogImage } from "src/utils/comman-methods"
import { DEFAULT_SPACE_PICTURE } from "../../config/constants"
import { FetchCurrentUserMe } from "src/generated/graphql"
import RecommendedListing from "./recommend-listing"
import MobileViewBlogs from "./mobile-view-more-blog"
import Author from "./Author"
import { InstagramEmbed } from "react-social-media-embed"

export type BolgListType = {
  id: string
  title: string
  description: string
  metaTitle: string
  metaDescription: string
  createdAt: string
  tag: { id: string; name: string }[]
  user:
    | FetchCurrentUserMe
    | {
        firstName: string
        avatarUrl: string
      }
  thumbnailUrl: string
  seen?: number
  avgReadingTime?: number
}

export type BlogUserType = {
  firstName: string
}

interface Props {
  client: ApolloClient<NormalizedCacheObject>
  authState: AuthenticationState
}

const SingleBlog = (props: Props) => {
  const { client, authState } = props
  const params: any = useLocation()
  const [data, setData] = useState<BolgListType>({
    createdAt: "",
    description: "",
    id: "",
    metaDescription: "",
    metaTitle: "",
    tag: [],
    thumbnailUrl: "",
    title: "",
    user: {
      firstName: "",
      avatarUrl: ""
    }
  })
  const [moreData, setMoreData] = useState<BolgListType[]>([])
  const [isMore, setIsMore] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const [allBlogs, setAllBlogs] = useState<BolgListType[]>([])
  const [contentWithAd, setContentWithAd] = useState<string[]>([])
  const [instaData, setInstaData] = useState<{ index: number; id: string }[]>([])
  const history = useHistory()

  const blogId = useMemo(() => {
    const searchQuery = params?.pathname?.split("/")[2]
    return searchQuery
  }, [params?.search, activeIndex])

  const blogTitle = useMemo(() => {
    try {
      return params.pathname.split("/")[3]
    } catch (err) {}
  }, [params?.search])

  const splitContentIntoParagraphs = content => {
    return content
      .split(/<\/p>/)
      .filter(Boolean)
      .map(paragraph => paragraph + "</p>")
  }

  const init = async () => {
    setLoading(true)
    const resp = await fetchBlog(client, blogId, false)
    if (resp && resp.data) {
      let { blog } = resp.data
      blog.description = await editAltToblogImage(blog.description, blog.title)

      const updatedDescription = blog.description
      const regex = /TOLOBI_IG_POST=([^<]+)/g

      let match
      const instaData:any = []
      while ((match = regex.exec(updatedDescription)) !== null) {
        const value = match[1]
        instaData.push({
          index: updatedDescription.substr(0, match.index).split("<p>").length - 2,
          id: value
        })
      }

      const paragraphs = splitContentIntoParagraphs(
        updatedDescription.replace(regex, "")
      )

      setInstaData(instaData)
      setData({ ...blog, description: updatedDescription })
      setContentWithAd(paragraphs)

      if (!activeIndex) {
        setAllBlogs(pre => [...pre, blog])
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    init()
  }, [activeIndex, blogId, client])

  useEffect(() => {
    fetchMoreBlog()
  }, [client, blogId, authState])

  const fetchMoreBlog = async () => {
    setIsMore(true)
    const resp = await fetchMoreBlogList(client, blogId, authState)
    if (resp && resp.data) {
      const { moreBlog } = resp.data
      setMoreData(moreBlog || [])
      setAllBlogs(pre => [...pre, ...moreBlog])
    }
    setIsMore(false)
  }

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" })

  const onNext = () => {
    let title = allBlogs[activeIndex + 1]?.title
    let id = allBlogs[activeIndex + 1]?.id
    let serachKey = `${removeExtraUrlSymbols(title)}`
    history.push({ pathname: `/blog/${id}/${serachKey}` })
    setActiveIndex((pre: number) => pre + 1)
  }

  const onPrev = () => {
    let title = allBlogs[activeIndex - 1]?.title
    let id = allBlogs[activeIndex - 1].id
    let serachKey = `${removeExtraUrlSymbols(title)}`
    history.push({ pathname: `/blog/${id}/${serachKey}` })
    setActiveIndex((pre: number) => pre - 1)
  }

  const renderSkeleton = () => <SkeletonLoading rows={4} imgHeight={"160px"} isImage />

  const renderCard = list => {
    const date = timeStampTo_M_Day(list?.createdAt)
    return (
      <Link
        to={{ pathname: `/blog/${list.id}/${removeExtraUrlSymbols(list?.title)}` }}
        target="_blank"
        rel="noreferrer"
      >
        <MoreBlogContainer key={list.id}>
          <ImageContainer>
            <MoreBlogImage
              src={(list.thumbnailUrl && list.thumbnailUrl) || images.imgCard}
              placeholder={DEFAULT_SPACE_PICTURE}
            />
          </ImageContainer>
          <BlogDetail>
            <Heading>{list.title}</Heading>
            <ClientDetail>
              <ClientImageSection>
                <Avatar size="blog" imageURL={list.user?.avatarUrl} />
              </ClientImageSection>
              <ClientName>
                {list.user["firstName"]}&nbsp; {list.user["lastName"]}&nbsp;&nbsp;
              </ClientName>
              <BlogDateTime>{date}</BlogDateTime>
            </ClientDetail>
          </BlogDetail>
        </MoreBlogContainer>
      </Link>
    )
  }

  return (
    <>
      <Helmet>
        <title>{data?.metaTitle}</title>
        <meta name="description" content={data?.metaDescription} />
        <link rel="canonical" href={window?.location?.href} />
        <meta property="og:title" content={data?.metaTitle} />
        <meta property="og:description" content={data?.metaDescription} />
      </Helmet>
      <BannerImageContainer>
        <Hero />
      </BannerImageContainer>
      <SingleBlogContainer>
        <TabContainer className="tab-container">
          {!loading ? (
            <Column width="100%">
              <TitleTxt>{data?.title}</TitleTxt>
              <DescText className="blog-container">
                {contentWithAd.map((paragraph, index) => (
                  <div key={index}>
                    <div
                      className="dangerousHtml"
                      dangerouslySetInnerHTML={{ __html: paragraph }}
                    />
                    {(index) % 4 === 0 && index > 1  && (
                      <GoogleAdSense
                        styles={{
                          width: 400,
                          height: 300,
                          float: "left",
                          borderRadius: 6,
                        }}
                      />
                    )}
                  
                    {instaData.some(insta => insta.index === index) && (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <InstagramEmbed
                          url={`https://www.instagram.com/p/${
                            instaData.find(insta => insta.index === index)?.id
                          }/`}
                          width={450}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </DescText>
              {data.tag?.length && (
                <TagContainer>
                  {data.tag.map((tag, index) => (
                    <Link
                      key={index}
                      to={{
                        pathname: `/blogs`,
                        search: `tags=${tag.name}`
                      }}
                      target="_blank"
                      rel="nofollow"
                    >
                      <TagsList>{tag.name}</TagsList>
                    </Link>
                  ))}
                </TagContainer>
              )}
              <Author authorData={data.user} />
              <div className="button-container" id="next-prev-btn">
                <Button type="dashed" onClick={onPrev} disabled={activeIndex === 0}>
                  Previous
                </Button>
                <Button
                  type="primary"
                  onClick={onNext}
                  disabled={activeIndex === allBlogs.length - 1}
                >
                  Next
                </Button>
              </div>
            </Column>
          ) : (
            <SkeletonLoading rows={10} imgHeight={"160px"} width={"100%"} />
          )}
        </TabContainer>

        {!isTabletOrMobile ? (
          <BlogListContainer>
            <DivCard>
              <Card style={{ marginBottom: "60px" }}>
                <Content>More Blogs</Content>
                <TopSection>
                  {isMore
                    ? [...Array(3)].map(() => (
                        <SkeletonLoading pd={"5px 10px"} rows={1} width={"100%"} avatar />
                      ))
                    : moreData && moreData.map(renderCard)}
                </TopSection>
              </Card>

              <GoogleAdSense
                styles={{
                  width: 400,
                  height: 300,
                  float: "left",
                  borderRadius: 6
                }}
              />
            </DivCard>
          </BlogListContainer>
        ) : (
          <Row flexWrap="wrap" justifyContent="center">
            {isMore ? (
              <SkeletonWrapper>{[...Array(2)].map(renderSkeleton)}</SkeletonWrapper>
            ) : (
              <MobileViewBlogs
                moreBlogs={moreData}
                loading={loading}
                isTabletOrMobile={isTabletOrMobile}
              />
            )}
          </Row>
        )}
      </SingleBlogContainer>
      <RecommendedListing isTabletOrMobile={isTabletOrMobile} />
      <GoogleAdSense
        styles={{
          width: "100%",
          height: 250,
          float: "left"
        }}
      />
      <script type="application/ld+json">
        {`
        {
         "@context": "https://schema.org",
         "@type": "Article",
         "@id":"${`https://www.tolobi.com/blog/${blogId}/${removeExtraUrlSymbols(data?.title)}`}",
         "headline": "${data?.metaTitle}",
         "image": "${data?.thumbnailUrl}",
         "url": "${`https://www.tolobi.com/blog/${blogId}/${removeExtraUrlSymbols(data?.title)}`}",
         "datePublished": "${new Date(Number(data?.createdAt)).toISOString()}",
         "dateModified": "${new Date(Number(data?.createdAt)).toISOString()}",
         "description": "${data?.metaDescription}",
         "author": [
          {
            "@type": "Person",
            "name": "${data?.user.firstName}",
            "url": "${data?.user.avatarUrl}"
            }
          ]
        }
      `}
      </script>
      <Footer />
    </>
  )
}

export default SingleBlog
